import React from 'react';
import { EnquiryFormModel } from '../models/EnquiryFormModel';
import { BackendApiServices } from '../services/BackendApiServices';
import logo from '../assets/Ecosystm-Awards-Logo.svg';
import './EnquiryForm.css';
import Cookies from 'js-cookie';
import { COOKIE_NAME, COOKIE_VALUE } from '../constants/Constants';
import Loading from './Loading';
import S3 from 'react-aws-s3';
import Popup from './Popup';


class EnquiryForm extends React.Component<{}, EnquiryFormModel> {
    state: EnquiryFormModel = {
        fullName: '',
        jobTitle: '',
        companyName: '',
        email: '',
        contact: '',
        companyWebsite: '',
        onBehalfOfOtherOrganisation: -1,
        categoryNominatingFor: [],
        detailsSubmission: '',
        fileUploadsRef: '',
        contactNameOfOrganisationOnBehalfOf: '',
        jobTitleOfContactOrganisationOnBehalfOf: '',
        nameOfOrganisationOnBehalfOf: '',
        emailOfContactOrganisationOnBehalfOf: '',
        contactNumberOfContactOrganisationOnBehalfOf: '',
        fileLocations: [],
    }
    filesUploaded = [];
    isLoading: boolean = false;
    isPopupVisible: boolean = false;
    errorMsg: string = "Error encountered! Try Again";
    backendApiService = new BackendApiServices();
    handleNameChange = (event: any) => {
        this.setState({
            fullName: event.target.value
        })
    }
    handleJobtitleChange = (event: any) => {
        this.setState({
            jobTitle: event.target.value
        })
    }
    handleCompanyNameChange = (event: any) => {
        this.setState({
            companyName: event.target.value
        })
    }
    handleEmailChange = (event: any) => {
        this.setState({
            email: event.target.value
        })
    }
    handleContactChange = (event: any) => {
        this.setState({
            contact: event.target.value
        })
    }
    handleCompanyWebsiteChange = (event: any) => {
        this.setState({
            companyWebsite: event.target.value
        })
    }
    handleOnBehalfOfOtherOrganisationChange = (event: any) => {
        this.setState({
            onBehalfOfOtherOrganisation: event.target.value === 'Yes' ? 1 : 0
        })
    }
    handleCategoryNominatingForChange = (event: any) => {
        if (!this.state.categoryNominatingFor.includes(event.target.value)) {
            let arr = this.state.categoryNominatingFor
            arr.push(event.target.value)
            this.setState({
                categoryNominatingFor: arr
            })
        } else {
            let arr = this.state.categoryNominatingFor
            let idx = arr.indexOf(event.target.value);
            if (idx >= 0) {
                arr.splice(idx, 1);
                this.setState({
                    categoryNominatingFor: arr
                })
            }
        }
        // this.setState({
        //     categoryNominatingFor: event.target.value
        // })
    }
    handleDetailsSubmissionChange = (event: any) => {
        this.setState({
            detailsSubmission: event.target.value
        })
    }
    handleFileUploadValidation = (event: any) => {
        this.filesUploaded = event.target.files;
    }
    handleContactNameOfOrganisationOnBehalfOfChange = (event: any) => {
        this.setState({
            contactNameOfOrganisationOnBehalfOf: event.target.value
        })
    }
    handleJobTitleOfContactOrganisationOnBehalfOfChange = (event: any) => {
        this.setState({
            jobTitleOfContactOrganisationOnBehalfOf: event.target.value
        })
    }
    handleNameOfOrganisationOnBehalfOfChange = (event: any) => {
        this.setState({
            nameOfOrganisationOnBehalfOf: event.target.value
        })
    }
    handleEmailOfContactOrganisationOnBehalfOfChange = (event: any) => {
        this.setState({
            emailOfContactOrganisationOnBehalfOf: event.target.value
        })
    }
    handleContactNumberOfContactOrganisationOnBehalfOfChange = (event: any) => {
        this.setState({
            contactNumberOfContactOrganisationOnBehalfOf: event.target.value
        })
    }
    handleFormSubmit = (event: any) => {
        event.preventDefault();
        this.isLoading = true;
        this.restrictScroll(true);
        this.forceUpdate();
        let uniqueDirName = '';
        if (this.filesUploaded.length > 0) {
            uniqueDirName = this.generateUniqueDirectory();
            this.setState({
                fileUploadsRef: uniqueDirName
            }, () => {
                this.uploadFilesTos3(uniqueDirName)
            })
        } else {
            this.sendFormDataToBackend();
        }

    }
    generateUniqueDirectory() {
        return Math.random().toString(36).substring(4, 12) + Math.random().toString(36).substring(4, 12);
    }
    handleUpload(file: any, s3: any) {
        return new Promise((resolve, reject) => {
            let newFileName = file.name.replace(/\..+$/, "");
            s3.uploadFile(file, newFileName).then((data: any) => {
                if (data.status === 204) {
                    resolve({
                        status: true,
                        message: file.name + " uploaded.",
                        location: data.location
                    })
                } else {
                    reject({
                        status: false,
                        message: file.name + " failed to upload."
                    })
                }
            }).catch((err: any) => {
                this.isLoading = false;
                this.showPopup("Error encountered while uploading files! Try Again ");
                console.log(err);
            })
        })
    }
    uploadFilesTos3(uniqueDirName: string) {
        const s3config = {
            bucketName: 'ecosystm-nomination',
            dirName: uniqueDirName,
            region: 'ap-southeast-1',
            accessKeyId: 'AKIA5XB4ULB56CDSBXHC',
            secretAccessKey: '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',
        }
        // const s3 = new ReactS3Client(s3config);
        const s3 = new S3(s3config);
        const promises: any[] = [];
        for (let i = 0; i < this.filesUploaded.length; i++) {
            promises.push(this.handleUpload(this.filesUploaded[i], s3));
        }
        Promise.all(promises).then((values) => {
            console.log(values);
            let locationArr: string[] = [];
            values.forEach(p => {
                if (!p.status) {
                    this.showPopup("Error uploading file(s)! Try Again");
                    return;
                }
                locationArr.push(p.location);
            })
            this.setState({
                fileLocations: locationArr
            }, () => {
                this.sendFormDataToBackend();
            })
        }).catch((err) => {
            this.isLoading = false;
            this.showPopup("Server encountered an error while saving, please try again")
            console.log(err)
        })
    }

    sendFormDataToBackend() {
        this.backendApiService.senEmailNotification(this.state).then(response=>{
            response.json().then((data)=>{
                console.log(data)
            })
        }).catch(err=>{
            console.log(err)
        })
        this.backendApiService.sendEnquiryDataToBackend(this.state).then(response => {
            response.json().then((data) => {
                if (data.statusCode === 200) {
                    Cookies.set(COOKIE_NAME, COOKIE_VALUE, { expires: 365 })
                    window.location.reload();
                } else {
                    this.isLoading = false;
                    this.showPopup('Server encountered an error while saving, please try again');
                }
                this.isLoading = false;
                this.restrictScroll(false);
                this.forceUpdate();
            })
        }).catch(err => {
            this.isLoading = false;
            this.showPopup('Server encountered an error while saving, please try again');
            console.log(err)
        })
    }

    showPopup(errorMsg: string) {
        this.errorMsg = errorMsg;
        this.isPopupVisible = true;
        this.restrictScroll(true);
        this.forceUpdate();
    }

    closePopup = () => {
        this.isPopupVisible = false;
        this.restrictScroll(false);
        this.forceUpdate();
    }

    restrictScroll(flag: boolean) {
        if (flag) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }
    }


    render() {
        return (
            <section className="text-gray-600 body-font relative custom-background">
                {this.isPopupVisible && <Popup content={this.errorMsg} handleClose={this.closePopup} />}
                {this.isLoading && <div className="loader-wrapper">
                    <div className="loader">
                        <Loading />
                    </div>
                </div>}
                <div className="container px-5 py-10 mx-auto">
                    <div className="flex flex-col text-white mx-auto lg:w-9/12 md:w-2/3 description-background sm:bg-right rounded p-5 pb-10 shadow-xl">
                        <div className="w-full my-10 md:mb-20"><img src={logo} className="lg:h-28 sm:h-16 h-12" alt="Ecosystm Logo" /></div>
                        <h1 className="sm:text-3xl lg:text-4xl text-xl font-black title-font mb-4 text-black">Ecosystm Global Digital Futures Awards Nomination</h1>
                        <p className="leading-relaxed text-base text-black my-3">The Ecosystm Global Digital Futures Awards are a yearly awards series which recognises excellence in the areas of FinTech, HealthTech, and Tech for Good. The Awards highlight organisations that are creating Impact, demonstrating Innovation and building Ecosystems to shape the Digital Future.</p>
                        <p className="leading-relaxed text-base text-black my-3">The Digital Futures Awards are an independent non-sponsored global awards program that evaluates organisations that are leading the way within their industry segment through digital innovation. Shortlisted nominations are then evaluated through a stringent judging process, using multiple, focused criteria by an international panel of judges that include renowned industry experts and influencers. A list of finalists is announced, from which a winner is selected.</p>
                        <p className="leading-relaxed text-base text-black my-3">There is no fee associated with nominations and the use of the associated Awards logo by the winners in their marketing activities.</p>
                    </div>
                    <form onSubmit={this.handleFormSubmit} method="post">
                        <div className="lg:w-9/12 md:w-2/3 mx-auto bg-white p-8 pb-28 shadow-xl rounded">
                            <div className="flex flex-wrap -m-2">
                                <div className="px-2 py-3 w-full">
                                    <div className="relative">
                                        <label className="field-names required">Full Name</label>
                                        <input type="text" id="name" placeholder="Enter your answer" required className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-red-500 focus:bg-white focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" value={this.state.fullName} onChange={this.handleNameChange} />
                                    </div>
                                </div>
                                <div className="px-2 py-3 w-full">
                                    <div className="relative">
                                        <label className="field-names required">Job Title</label>
                                        <input type="text" id="jobTitle" name="jobTitle" placeholder="Enter your answer" required className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-red-500 focus:bg-white focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" value={this.state.jobTitle} onChange={this.handleJobtitleChange} />
                                    </div>
                                </div>
                                <div className="px-2 py-3 w-full">
                                    <div className="relative">
                                        <label className="field-names required">Company Name</label>
                                        <input type="text" id="compName" name="compName" placeholder="Enter your answer" required className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-red-500 focus:bg-white focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" value={this.state.companyName} onChange={this.handleCompanyNameChange} />
                                    </div>
                                </div>
                                <div className="px-2 py-3 w-full">
                                    <div className="relative">
                                        <label className="field-names required">Email Address</label>
                                        <input type="email" id="email" name="email" placeholder="Enter your answer" required className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-red-500 focus:bg-white focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" value={this.state.email} onChange={this.handleEmailChange} />
                                    </div>
                                </div>
                                <div className="px-2 py-3 w-full">
                                    <div className="relative">
                                        <label className="field-names">Contact Number</label>
                                        <input type="text" id="contact" name="contact" placeholder="Enter your answer" className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-red-500 focus:bg-white focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" value={this.state.contact} onChange={this.handleContactChange} />
                                    </div>
                                </div>
                                <div className="px-2 py-3 w-full">
                                    <div className="relative">
                                        <label className="field-names">Company Website URL</label>
                                        <input type="text" id="companywebsite" name="companywebsite" placeholder="Enter your answer" className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-red-500 focus:bg-white focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" value={this.state.companyWebsite} onChange={this.handleCompanyWebsiteChange} />
                                    </div>
                                </div>
                                <div className="px-2 py-3 w-full">
                                    <div className="relative">
                                        <label className="field-names required">Are you applying on behalf of another organisation?</label>
                                        <div className="flex">
                                            <div className="w-1/5">
                                                <label className="leading-7 text-sm text-gray-600 flex items-center">
                                                    <input type="radio" id="optionYes" name="otherOrganisation" className="h-4 w-4 mx-1 bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-red-500 focus:bg-white focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" value="Yes" onChange={this.handleOnBehalfOfOtherOrganisationChange} required />
                                                    Yes
                                                </label>
                                            </div>
                                            <div className="w-1/5">
                                                <label className="leading-7 text-sm text-gray-600 flex items-center">
                                                    <input type="radio" id="optionNo" name="otherOrganisation" className="h-4 w-4 mx-1 bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-red-500 focus:bg-white focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" value="No" onChange={this.handleOnBehalfOfOtherOrganisationChange} />
                                                    No
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-2 py-3 w-full" hidden={this.state.onBehalfOfOtherOrganisation !== 1}>
                                    <div className="relative">
                                        <label className="field-names required">Contact name within the organisation you are applying on behalf of</label>
                                        <input type="text" id="contactNameOfOrganisationOnBehalfOf" name="contactNameOfOrganisationOnBehalfOf" placeholder="Enter your answer" required={this.state.onBehalfOfOtherOrganisation === 1} className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-red-500 focus:bg-white focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" value={this.state.contactNameOfOrganisationOnBehalfOf} onChange={this.handleContactNameOfOrganisationOnBehalfOfChange} />
                                    </div>
                                </div>
                                <div className="px-2 py-3 w-full" hidden={this.state.onBehalfOfOtherOrganisation !== 1}>
                                    <div className="relative">
                                        <label className="field-names required">Job title of contact in the organisation you are applying on behalf of</label>
                                        <input type="text" id="jobTitleOfContactOrganisationOnBehalfOf" name="jobTitleOfContactOrganisationOnBehalfOf" placeholder="Enter your answer" required={this.state.onBehalfOfOtherOrganisation === 1} className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-red-500 focus:bg-white focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" value={this.state.jobTitleOfContactOrganisationOnBehalfOf} onChange={this.handleJobTitleOfContactOrganisationOnBehalfOfChange} />
                                    </div>
                                </div>
                                <div className="px-2 py-3 w-full" hidden={this.state.onBehalfOfOtherOrganisation !== 1}>
                                    <div className="relative">
                                        <label className="field-names required">The name of organisation you are applying on behalf of</label>
                                        <input type="text" id="nameOfOrganisationOnBehalfOf" name="nameOfOrganisationOnBehalfOf" placeholder="Enter your answer" required={this.state.onBehalfOfOtherOrganisation === 1} className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-red-500 focus:bg-white focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" value={this.state.nameOfOrganisationOnBehalfOf} onChange={this.handleNameOfOrganisationOnBehalfOfChange} />
                                    </div>
                                </div>
                                <div className="px-2 py-3 w-full" hidden={this.state.onBehalfOfOtherOrganisation !== 1}>
                                    <div className="relative">
                                        <label className="field-names required">Email address for the contact in the organisation you are applying on behalf of</label>
                                        <input type="text" id="emailOfContactOrganisationOnBehalfOf" name="emailOfContactOrganisationOnBehalfOf" placeholder="Enter your answer" required={this.state.onBehalfOfOtherOrganisation === 1} className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-red-500 focus:bg-white focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" value={this.state.emailOfContactOrganisationOnBehalfOf} onChange={this.handleEmailOfContactOrganisationOnBehalfOfChange} />
                                    </div>
                                </div>
                                <div className="px-2 py-3 w-full" hidden={this.state.onBehalfOfOtherOrganisation !== 1}>
                                    <div className="relative">
                                        <label className="field-names">Contact number for the contact in the organisation you are applying on behalf of</label>
                                        <input type="text" id="contactNumberOfContactOrganisationOnBehalfOf" name="contactNumberOfContactOrganisationOnBehalfOf" placeholder="Enter your answer" className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-red-500 focus:bg-white focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" value={this.state.contactNumberOfContactOrganisationOnBehalfOf} onChange={this.handleContactNumberOfContactOrganisationOnBehalfOfChange} />
                                    </div>
                                </div>
                                <div className="px-2 py-3 w-full">
                                    <div className="relative">
                                        <label className="field-names required">Name of the category you are nominating for (Select all that apply)</label>
                                        <div>
                                            <div className="pt-2">
                                                <label className="leading-7 text-md text-gray-600 flex items-center w-max category-field">
                                                    <input type="checkbox" id="customer_experience" name="categoryNominatingFor" className="h-4 w-4 mx-1 bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-red-500 focus:bg-white focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" value="customer_experience" required={this.state.categoryNominatingFor.length < 1} onChange={this.handleCategoryNominatingForChange} />
                                                    <b>Customer Experience:</b>
                                                </label>
                                                <div className="pl-5"><i className="leading-7 text-md text-gray-600 category-field-desc">Recognising organisations that are driving an exceptional experience for their customers and setting a new benchmark within the industry</i></div>
                                            </div>
                                            <div className="pt-2">
                                                <label className="leading-7 text-md text-gray-600 flex items-center w-max category-field">
                                                    <input type="checkbox" id="global_payments_award" name="categoryNominatingFor" className="h-4 w-4 mx-1 bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-red-500 focus:bg-white focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" value="global_payments_award" required={this.state.categoryNominatingFor.length < 1} onChange={this.handleCategoryNominatingForChange} />
                                                    <b>Global Payments Award:</b>
                                                </label>
                                                <div className="pl-5"><i className="leading-7 text-md text-gray-600 category-field-desc">Recognising innovative use of technology and business models in Payments in areas such as Unified Payment Interface (UPI), Peer-2-Peer (P2P) transaction methods, Digital Wallet, Mobile-Point-Of-Sale (mPOS) and Voice Payment</i></div>
                                            </div>
                                            <div className="pt-2">
                                                <label className="leading-7 text-md text-gray-600 flex items-center w-max category-field">
                                                    <input type="checkbox" id="global_lending_award" name="categoryNominatingFor" className="h-4 w-4 mx-1 bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-red-500 focus:bg-white focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" value="global_lending_award" required={this.state.categoryNominatingFor.length < 1} onChange={this.handleCategoryNominatingForChange} />
                                                    <b>Global Lending Award:</b>
                                                </label>
                                                <div className="pl-5"><i className="leading-7 text-md text-gray-600 category-field-desc">Recognising innovation in Alternative Finance in areas such as microfinance for individuals and small & medium enterprises, P2P lending and crowdfunding</i></div>
                                            </div>
                                            <div className="pt-2">
                                                <label className="leading-7 text-md text-gray-600 flex items-center w-max category-field">
                                                    <input type="checkbox" id="global_banking_award" name="categoryNominatingFor" className="h-4 w-4 mx-1 bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-red-500 focus:bg-white focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" value="global_banking_award" required={this.state.categoryNominatingFor.length < 1} onChange={this.handleCategoryNominatingForChange} />
                                                    <b>Global Banking Award:</b>
                                                </label>
                                                <div className="pl-5"><i className="leading-7 text-md text-gray-600 category-field-desc">Recognising banks and financial services organisations that embrace digital technology for excellence in customer experience, process efficiency and/or compliance</i></div>
                                            </div>
                                            <div className="pt-2">
                                                <label className="leading-7 text-md text-gray-600 flex items-center w-max category-field">
                                                    <input type="checkbox" id="global_insuretech_award" name="categoryNominatingFor" className="h-4 w-4 mx-1 bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-red-500 focus:bg-white focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" value="global_insuretech_award" required={this.state.categoryNominatingFor.length < 1} onChange={this.handleCategoryNominatingForChange} />
                                                    <b>Global InsureTech Award:</b>
                                                </label>
                                                <div className="pl-5"><i className="leading-7 text-md text-gray-600 category-field-desc">Recognising excellence and innovation in InsureTech in areas such as micro-insurance, usage-based pricing, process optimisation and underwriting efficiency</i></div>
                                            </div>
                                            <div className="pt-2">
                                                <label className="leading-7 text-md text-gray-600 flex items-center w-max category-field">
                                                    <input type="checkbox" id="financial_inclusion_impact_award" name="categoryNominatingFor" className="h-4 w-4 mx-1 bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-red-500 focus:bg-white focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" value="financial_inclusion_impact_award" required={this.state.categoryNominatingFor.length < 1} onChange={this.handleCategoryNominatingForChange} />
                                                    <b>Financial Inclusion Impact Award:</b>
                                                </label>
                                                <div className="pl-5"><i className="leading-7 text-md text-gray-600 category-field-desc">Recognising organisations that promote financial inclusion in the unbanked and the underbanked with a focus on bridging the economic divide</i></div>
                                            </div>
                                            <div className="pt-2">
                                                <label className="leading-7 text-md text-gray-600 flex items-center w-max category-field">
                                                    <input type="checkbox" id="global_platform_award" name="categoryNominatingFor" className="h-4 w-4 mx-1 bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-red-500 focus:bg-white focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" value="global_platform_award" required={this.state.categoryNominatingFor.length < 1} onChange={this.handleCategoryNominatingForChange} />
                                                    <b>Global Platform Award:</b>
                                                </label>
                                                <div className="pl-5"><i className="leading-7 text-md text-gray-600 category-field-desc">Recognising organisations that provide a platform to bring together industry stakeholders such as Financial Services Institutions and Innovative FinTechs, to drive ease of collaboration and innovation by accelerating proof of concept deployments in a frictionless manner</i></div>
                                            </div>
                                            <div className="pt-2">
                                                <label className="leading-7 text-md text-gray-600 flex items-center w-max category-field">
                                                    <input type="checkbox" id="sustainable_finance_impact_award" name="categoryNominatingFor" className="h-4 w-4 mx-1 bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-red-500 focus:bg-white focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" value="sustainable_finance_impact_award" required={this.state.categoryNominatingFor.length < 1} onChange={this.handleCategoryNominatingForChange} />
                                                    <b>Sustainable Finance Impact Award:</b>
                                                </label>
                                                <div className="pl-5"><i className="leading-7 text-md text-gray-600 category-field-desc">Recognising organisations that promote sustainable finance and have ESG values</i></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-2 py-3 w-full">
                                    <div className="relative">
                                        <label className="field-names required">Details of the submission and why you think your Organisation should be shortlisted</label>
                                        <textarea id="detailsSub" name="detailsSub" placeholder="Enter your answer" required className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-red-500 focus:bg-white focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" value={this.state.detailsSubmission} onChange={this.handleDetailsSubmissionChange} />
                                    </div>
                                </div>
                                <div className="px-2 py-3 w-full">
                                    <div className="relative">
                                        <label className="field-names">Upload your supporting documents here</label>
                                        <input type="file" id="file" name="file" multiple accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx" className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-red-500 focus:bg-white focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" onChange={this.handleFileUploadValidation} />
                                    </div>
                                </div>
                                <div className="px-2 py-3 w-full">
                                    <button type="submit" className="flex text-white bg-red-500 border-0 py-2 px-8 focus:outline-none hover:bg-red-600 rounded text-lg">Submit</button>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="mx-auto lg:w-9/12 md:w-2/3 mt-4">
                        Terms & Conditions:
                        <ol type="i">
                            <li key={0}>i. By submitting your nomination you confirm that you have approval from your organisation (or the organisations on whose behalf you are nominating) to provide this information.</li>
                            <li key={1}>ii. You also agree that we may contact you to obtain additional information to judge your nomination.</li>
                            <li key={2}>iii. By submitting your nomination you agree to our <a href="https://www.ecosystm360.com/#/terms-of-use" className="text-blue-400 hover:underline visited:text-purple-600">Terms of Use</a> and <a href="https://www.ecosystm360.com/#/privacy-policy" className="text-blue-400 hover:underline visited:text-purple-600">Privacy Policy</a>.</li>
                        </ol>
                    </div>
                </div>
            </section>
        )
    }
}

export default EnquiryForm
